import {listToReadable} from 'util/NameUtil';

import {flatMapOverBlocks} from '../lib';
import * as uiBlock from '../ui-blocks/UiBlockTypes';
import {ValidationMessage} from './ValidationBanners';

const missingInputsMessages = (blocks: Array<uiBlock.UiBlock>): Array<ValidationMessage> => {
  // nameIfMissing: returns the block label if the block is required. Wraps in an array so we can flatMap.
  const nameIfMissing = (block: uiBlock.UiBlock): Array<string> => {
    if (uiBlock.isUserInputBlock(block) && block.required) {
      // The backend has validation preventing required=True and label=null
      const blockLabel = block.label!;
      if (uiBlock.isMultiValueUserInputBlock(block)) {
        const valuesLength = block.blockValue?.values?.length;
        return valuesLength === undefined || valuesLength === 0 ? [blockLabel] : [];
      }
      // TODO(BNCH-77206) update to always use `blockValue`
      return block.value == null || block.value.length === 0 ? [blockLabel] : [];
    }
    return [];
  };

  const missingInputNames = flatMapOverBlocks(blocks, nameIfMissing);
  return missingInputNames.length > 0
    ? [
        {
          title: 'Missing required fields',
          body: `Fill out all required fields to continue: ${listToReadable(missingInputNames)}.`,
        },
      ]
    : [];
};

export const validateInputs = (
  blocks: Array<uiBlock.UiBlock>,
  setValidationMessages: React.Dispatch<React.SetStateAction<Array<ValidationMessage>>>
): boolean => {
  const newValidationMessages: Array<ValidationMessage> = [
    ...missingInputsMessages(blocks),
    // Append future validation messages here
  ];
  setValidationMessages(newValidationMessages);
  return newValidationMessages.length === 0;
};
